export default `# Session Tasks

The tasks panel lets you delegate research, analysis, and prototyping work to a multi-agent system that runs asynchronously alongside your session.

---

## Task Categories

Tasks are organised into two categories:

- **Thinking** — Research and analysis tasks (e.g. competitive analysis, feasibility studies, market research)
- **Doing** — Implementation and prototyping tasks (e.g. scaffold generation, proof-of-concept code)

---

## Stats Overview

Three cards track your task pipeline:
- **Active Tasks** (blue) — Currently running
- **Completed** (green) — Successfully finished
- **Failed** (red) — Encountered errors

---

## Creating Tasks

Click **Create Task** to open the task creation dialog. Define what you need and the system will assign it to the appropriate agents.

---

## Task Statuses

| Status | Meaning |
|--------|---------|
| Not Started | Queued, waiting to begin |
| Running | Agents are actively working (shows duration) |
| Waiting for Human | Task is paused, needs your input |
| Completed | Finished successfully |
| Failed | Encountered an error |
| Cancelled | Stopped by you |

A **"May be stuck"** warning appears if a task has been running for more than 10 minutes.

---

## Managing Tasks

### Active Tasks
- **Review Now** — Respond to tasks waiting for human input
- **Cancel** — Stop a running task

### Completed Tasks
- **Add to Context** — Include the task results in the session's AI context, so avatars can reference them
- **View** — See full task details and output
- **Rerun** — Restart a task with the same parameters

---

## Tips

- **Add completed results to context** — This makes research findings available to avatars, enriching the discussion
- **Use Thinking tasks for research** — Let agents gather data while you focus on facilitation
- **Don't wait for tasks to finish** — They run asynchronously; continue your session and check back later
- **Rerun failed tasks** — Transient errors are common; a retry often succeeds`;
